module.exports = {"top":":item em destaque","item":":item","errors":{"noItemFound":":item Não encontrado","nothingFound":"Nada foi encontrado."}};